import styles from '@/app/components/category/parameters/CategoryParameters.module.scss';

const FilterGroupSkeleton = () => {
  return (
    <div className={`${styles.item} animate-pulse`}>
      <div className="flex items-center justify-between mb-3">
        <div className="h-4 w-2/3 bg-grey rounded"></div>
        <div className="h-3 w-6 bg-grey rounded"></div>
      </div>
      <div className="space-y-3">
        <div className="h-4 w-full bg-grey rounded"></div>
        <div className="h-4 w-3/4 bg-grey rounded"></div>
        <div className="h-4 w-5/6 bg-grey rounded"></div>
      </div>
      <div className="mt-4 h-px w-full bg-grey"></div>
    </div>
  );
};

const PriceFilterSkeleton = () => {
  return (
    <div className={`${styles.item} animate-pulse`}>
      <div className="h-4 w-24 bg-grey rounded mb-4"></div>
      <div className="h-2 w-full bg-grey rounded mb-4"></div>
      <div className="flex items-center justify-between">
        <div className="h-4 w-20 bg-grey rounded"></div>
        <div className="h-4 w-20 bg-grey rounded"></div>
      </div>
    </div>
  );
};

const CategoryFiltersSidebarSkeleton = ({ groupCount = 4 }) => {
  return (
    <div className={styles.wrapper}>
      <aside className={`${styles.sidebar} ${styles.isLoading}`}>
        <div className={styles.sidebarContent}>
          <div className={`${styles.filterTitle} animate-pulse d-block d-lg-none mb-3`}>
            <div className="flex items-center justify-between gap-3">
              <div className="h-6 w-32 bg-grey rounded"></div>
              <div className="h-8 w-8 bg-grey rounded-full"></div>
            </div>
          </div>

          <PriceFilterSkeleton />

          {Array.from({ length: groupCount }).map((_, index) => (
            <FilterGroupSkeleton key={`filter-skeleton-${index}`} />
          ))}

          <div className="text-center mt-6 animate-pulse">
            <div className={`${styles.showAll} inline-flex h-10 w-40 bg-grey rounded-full`}></div>
          </div>

          <div className={`${styles.buttonWrapper} mt-6 animate-pulse`}>
            <div className="h-11 w-full bg-grey rounded"></div>
          </div>
        </div>
      </aside>
    </div>
  );
};

export default CategoryFiltersSidebarSkeleton;
